import styled from 'styled-components';
import Button from 'components/Button';

export const CallToAction = styled(Button)`
    width: 200px;
    height: 40px;
    border-radius: 10px;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: white;
    opacity: 0.95;
    margin: auto;
    margin-top: 20px;
    &:hover{
      opacity: 1;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        width: 100%;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

export const CartContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: 100px 0px 50px 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const ContainerBreadcrumbs = styled.div`
    width: 100%;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-decoration-line: underline;
    color: #D6E1EF;
    opacity: 0.8;
    &>svg{
        margin: 0px 10px;
        margin-bottom: 6px;
    }
    @media only screen and (max-width: 768px) {
        font-size: 20px;
        &>svg{
            margin: 0px 10px;
            margin-bottom: 4px;
            height: 15px;
        }
    }
`;

export const ShopLink = styled.span`
    cursor: pointer;
`;

export const CartEmptyIndicator = styled.div`
    width: 100%;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 20px;
    line-height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-decoration-line: underline;
    color: #D6E1EF;
    opacity: 0.8;
    margin-top: 20px;
`;